module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_desc.5de7bdb6.svg";